module.exports = __webpack_public_path__ + "static/media/Billabong.52b04f1c.ttf";